import { render, staticRenderFns } from "./library-detail.vue?vue&type=template&id=74dfd758&scoped=true"
import script from "./library-detail.vue?vue&type=script&lang=js"
export * from "./library-detail.vue?vue&type=script&lang=js"
import style0 from "./library-detail.vue?vue&type=style&index=0&id=74dfd758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfd758",
  null
  
)

export default component.exports